import CalendarMinus from '@app/components/icons/calendar-minus';
import { T } from '@app/components/translation';

import Insight from './insight';

const WithoutDuration = () => (
  <Insight
    IconComponent={CalendarMinus}
    insight={
      <T
        _str="Without duration"
        _comment="Insight for contracts with no duration type. Visible in contract card."
      />
    }
  />
);

export default WithoutDuration;
